import { BaseEnum } from './BaseEnum';

export const PortalEvents = {
    None: 'none',
    Unauthorized: 'unauthorized',
    NetworkError: 'network-error',

    ...BaseEnum,
};
